import GenericBox from "components/ui/Box";
import { Sizes } from "enums/sizes";
import { useSubscriptionProcessState } from "features/subscription-process/contexts/selectors/selectors";
import { SubscriptionProcessContext, useSubscriptionProcess } from "features/subscription-process/contexts/SubscriptionProcessContext";
import { useDialog } from "hooks/useDialog";
import { Building2 } from "lucide-react";
import { useCallback } from "react";

import { usePricingParcContext } from "../../contexts/PricingParcContext";
import { ParcConfigurationTab } from "./ParcConfigurationTab";

/**
 * Carte d'en-tête en contexte parc. Auto-portée : un clic ouvre la configuration des biens
 * dans une modale (comme InsuredPropertyCard ouvre le formulaire du bien).
 */
export const ParcEntityCard: React.FC = () => {
  const { riskId } = useSubscriptionProcessState();
  const contextValue = useSubscriptionProcess();
  const { config, refetch } = usePricingParcContext();
  const { openDialog, closeDialog } = useDialog();

  const biensCount = config?.biensInclus?.length ?? 0;

  const onSelect = useCallback(() => {
    if (!riskId) return;
    openDialog(
      { title: "Configuration du parc immobilier", size: Sizes["4xl"] },
      // La modale est rendue dans un portail : on re-fournit le contexte de souscription
      // (nécessaire à GuaranteeFilter via useSubscriptionProcessState).
      <SubscriptionProcessContext.Provider value={contextValue}>
        <ParcConfigurationTab
          riskId={riskId}
          config={config}
          onSaved={() => {
            refetch();
            closeDialog();
          }}
        />
      </SubscriptionProcessContext.Provider>
    );
  }, [riskId, contextValue, config, openDialog, closeDialog, refetch]);

  return (
    <GenericBox onSelect={onSelect} icon={Building2} title="Parc immobilier">
      <button
        type="button"
        onClick={onSelect}
        className="text-sm text-primary text-left hover:underline"
      >
        {biensCount > 0
          ? `Personnaliser les garanties des ${biensCount} bien${biensCount > 1 ? "s" : ""}`
          : "Personnaliser les garanties par bien"}
      </button>
    </GenericBox>
  );
};
